module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_1001356.41a0c08a.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/ift/InternetSatF/FormatoSimplificado_1001356.pdf
// module id = 347
// module chunks = 0